import React from 'react';

/** Format & badge untuk halaman Riwayat Import Foto Menu. Semua aman untuk nilai kosong. */

const WIB = 'Asia/Jakarta';

export const formatRupiah = (amount?: number | null): string =>
  amount === null || amount === undefined || Number.isNaN(amount)
    ? '—'
    : new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', maximumFractionDigits: 0 }).format(amount);

export const formatUsd = (amount?: number | null): string => {
  if (amount === null || amount === undefined || Number.isNaN(amount)) return '—';
  // Biaya per import sering di bawah 1 sen: tampilkan 4 desimal.
  return `$${amount.toLocaleString('en-US', { minimumFractionDigits: amount >= 1 ? 2 : 4, maximumFractionDigits: 4 })}`;
};

export const formatNumber = (value?: number | null): string =>
  value === null || value === undefined || Number.isNaN(value) ? '—' : new Intl.NumberFormat('id-ID').format(value);

export const formatCompact = (value?: number | null): string =>
  value === null || value === undefined || Number.isNaN(value)
    ? '—'
    : new Intl.NumberFormat('id-ID', { notation: 'compact', maximumFractionDigits: 1 }).format(value);

export const formatDuration = (seconds?: number | null): string => {
  if (seconds === null || seconds === undefined || Number.isNaN(seconds)) return '—';
  const total = Math.round(seconds);
  if (total < 60) return `${total} dtk`;
  const minutes = Math.floor(total / 60);
  const rest = total % 60;
  return rest > 0 ? `${minutes} mnt ${rest} dtk` : `${minutes} mnt`;
};

export const formatDateTimeWib = (value?: string | null): string => {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return `${date.toLocaleString('id-ID', {
    timeZone: WIB,
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })} WIB`;
};

/** Tanggal hari ini (Y-m-d) menurut WIB. */
const todayWib = (): { year: number; month: number } => {
  const [year, month] = new Intl.DateTimeFormat('en-CA', { timeZone: WIB, year: 'numeric', month: '2-digit' })
    .format(new Date())
    .split('-')
    .map(Number);
  return { year, month };
};

/** Rentang bulan ini menurut WIB: [tanggal 1, tanggal terakhir] dalam format Y-m-d. */
export const thisMonthWib = (): { from: string; to: string } => {
  const { year, month } = todayWib();
  const lastDay = new Date(Date.UTC(year, month, 0)).getUTCDate();
  const mm = String(month).padStart(2, '0');
  return { from: `${year}-${mm}-01`, to: `${year}-${mm}-${String(lastDay).padStart(2, '0')}` };
};

const RESULT_STYLES: Record<string, string> = {
  success: 'bg-green-100 text-green-800',
  failed: 'bg-red-100 text-red-800',
  pending: 'bg-yellow-100 text-yellow-800',
  cancelled: 'bg-gray-100 text-gray-700',
};

const RESULT_LABELS: Record<string, string> = {
  success: 'Berhasil',
  failed: 'Gagal',
  pending: 'Pending',
  cancelled: 'Dibatalkan',
};

export const menuImportResultBadge = (result?: string | null, label?: string | null): React.ReactElement => (
  <span className={`inline-flex px-2 py-0.5 rounded text-xs font-semibold ${RESULT_STYLES[result ?? ''] ?? 'bg-gray-100 text-gray-800'}`}>
    {label || RESULT_LABELS[result ?? ''] || result || '—'}
  </span>
);
